/** @format */

import { Action, createReducer, on } from '@ngrx/store';
import {
  compareBarProductAdded,
  compareBarProductRemoved,
  compareBarProductsCleared,
  compareDrawerClosed,
  compareDrawerOpened,
  compareProductDetailsFetchFailed,
  compareProductDetailsFetchRetryTriggered,
  compareProductDetailsFetchSucceeded,
  compareProductDetailsFetchTriggered,
  compareProductsAvailabilityFetched,
  setCompareBarProducts,
} from './compare.actions';
import {
  plpResolverAPIDataInitialized,
  srlpResolverAPIDataInitialized,
} from '@plp/data-access/state';

import { CompareState } from '@plp/data-access/interfaces';

export const initialCompareState: CompareState = {
  compareBarProducts: [],
  compareProductsAvailability: { ecodeMessagingMap: {} },
  hasProductDetailsCallFailed: false,
  isCompareGridOpen: false,
  isCompareSkeletonLoaderVisible: true,
  isCompareHydrated: false,
  productDetails: null,
};

const productCompareReducer = createReducer(
  initialCompareState,
  on(setCompareBarProducts, (state, { compareBarProducts }) => ({
    ...state,
    compareBarProducts,
    isCompareHydrated: true,
  })),
  on(compareBarProductsCleared, (state) => ({
    ...state,
    compareBarProducts: [],
  })),
  on(compareBarProductRemoved, (state, { ecode }) => {
    const compareBarProducts = state.compareBarProducts.filter((cp) => cp.ecode !== ecode);

    const updatedProducts = state.productDetails?.products.filter(
      (product) => product.style.partNumber !== ecode,
    );

    const productDetails =
      state.productDetails && updatedProducts && updatedProducts.length > 0
        ? { ...state.productDetails, products: updatedProducts }
        : null;

    return {
      ...state,
      compareBarProducts,
      productDetails,
    };
  }),
  on(
    plpResolverAPIDataInitialized,
    srlpResolverAPIDataInitialized,
    (state, { data: { compareBarProducts } }) => ({
      ...state,
      compareBarProducts,
      isCompareHydrated: true,
    }),
  ),
  on(compareBarProductAdded, (state, { compareBarProduct }) => {
    const newCompareList = [...state.compareBarProducts, compareBarProduct];
    return {
      ...state,
      compareBarProducts: newCompareList,
    };
  }),
  on(compareDrawerOpened, (state) => ({
    ...state,
    isCompareGridOpen: true,
  })),
  on(compareDrawerClosed, (state) => ({
    ...state,
    isCompareGridOpen: false,
  })),
  on(compareProductsAvailabilityFetched, (state, { compareProductsAvailability }) => ({
    ...state,
    compareProductsAvailability,
  })),
  on(compareProductDetailsFetchTriggered, compareProductDetailsFetchRetryTriggered, (state) => ({
    ...state,
    isCompareSkeletonLoaderVisible: true,
  })),
  on(compareProductDetailsFetchSucceeded, (state, { productDetails }) => ({
    ...state,
    productDetails,
    hasProductDetailsCallFailed: false,
    isCompareSkeletonLoaderVisible: false,
  })),
  on(compareProductDetailsFetchFailed, (state) => ({
    ...state,
    hasProductDetailsCallFailed: true,
    isCompareSkeletonLoaderVisible: false,
  })),
);

export function compareReducer(state: CompareState | undefined, action: Action) {
  return productCompareReducer(state, action);
}
